import {dateToDDMMYYYY} from '$utils/date';
import {truncateText} from '$modules/frontdesk/utils';

interface PatientDetail {
  label: string;
  value: string;
  labelVariant: 'subtitle1' | 'subtitle2';
  titleVariant: 'subtitle1' | 'subtitle2';
  containsTooltip: boolean;
  helperFunction: ((value: string) => string) | null;
  className: string;
  gridSpan?: number;
}

export const PATIENT_DETAILS_MAP: PatientDetail[] = [
  {
    label: 'Gender',
    value: 'gender',
    labelVariant: 'subtitle1',
    titleVariant: 'subtitle2',
    containsTooltip: false,
    helperFunction: null,
    className: '',
  },

  {
    label: 'Date of birth',
    value: 'dob',
    labelVariant: 'subtitle1',
    titleVariant: 'subtitle2',
    containsTooltip: false,
    helperFunction: dateToDDMMYYYY,
    className: 'mb-1',
  },

  {
    label: 'Self booking',
    value: 'self_booking',
    labelVariant: 'subtitle1',
    titleVariant: 'subtitle2',
    containsTooltip: false,
    helperFunction: null,
    className: 'mb-1',
  },

  {
    label: 'GP or optician referral',
    value: 'referred_by_physician',
    labelVariant: 'subtitle1',
    titleVariant: 'subtitle2',
    containsTooltip: false,
    helperFunction: null,
    className: 'mb-1',
  },

  {
    label: 'Address',
    value: 'line1',
    labelVariant: 'subtitle1',
    titleVariant: 'subtitle2',
    containsTooltip: true,
    helperFunction: truncateText,
    className: 'mb-1',
  },

  {
    label: 'Post code',
    value: 'postcode',
    labelVariant: 'subtitle1',
    titleVariant: 'subtitle2',
    containsTooltip: false,
    helperFunction: null,
    className: 'mb-1',
  },

  {
    label: 'Town or city',
    value: 'city_name',
    labelVariant: 'subtitle1',
    titleVariant: 'subtitle2',
    containsTooltip: true,
    helperFunction: null,
    className: 'mb-1',
  },

  {
    label: 'Country',
    value: 'country_name',
    labelVariant: 'subtitle1',
    titleVariant: 'subtitle2',
    containsTooltip: true,
    helperFunction: null,
    className: 'mb-1',
  },

  {
    label: 'Reason of booking',
    value: 'reason',
    labelVariant: 'subtitle1',
    titleVariant: 'subtitle2',
    containsTooltip: false,
    helperFunction: null,
    className: 'mb-1',
    gridSpan: 3,
  },
];

export const BOOKING_PAYMENT_DETAILS_STRINGS = {
  unpaidTitle: "Select the Patient's Payment Method",
  unpaidSubtitle:
    "To complete the payment for this visit, please choose the patient's preferred method from the options below.",
  paidTitle: 'Payment details',
  paidSubtitle:
    'Check the payment summary, generate invoices, and modify the payment.',
  invoiceDetails: 'Invoice details',
  totalPayment: 'Total paid:',
  totalToPay: 'Total to pay:',
  consultationLabel: 'Surgery Consultation',
  noPaymentDetails: 'No payment details found',
  back: 'Back',
  takePayment: 'Take payment',
  selectPaymentMethodLabel: 'Select a payment method',
  paymentLinkLabel: 'Choose an option',
  loadingPaymentMethods: 'Loading...',
  errorLoadingPaymentMethods: 'Error loading options',
  confirmPaymentTitle: 'Confirm payment',
  confirmPaymentMessage:
    'Are you sure you want to proceed with taking the payment? Please verify the payment method before confirming.',
  paymentMethodLabel: 'Payment method',
  cancel: 'Cancel',
  confirm: 'Confirm',
};

export const PAYMENT_SUCCESS_STRINGS = {
  title: 'Payment successful',
  subtitleLine1: 'The payment has been recorded on the platform.You can now ',
  subtitleLine2: 'send the  payment receipt to the patient',
  back: 'Back',
  continue: 'Continue and send receipt',
  downloadReceipt: 'Download receipt',
};
export const PAYMENT_STATUS_MAP = {
  unpaid: {
    title: BOOKING_PAYMENT_DETAILS_STRINGS.unpaidTitle,
    subtitle: BOOKING_PAYMENT_DETAILS_STRINGS.unpaidSubtitle,
  },
  paid: {
    title: BOOKING_PAYMENT_DETAILS_STRINGS.paidTitle,
    subtitle: BOOKING_PAYMENT_DETAILS_STRINGS.paidSubtitle,
  },
};
